export const CONDITION_INVENTORY = ["Rusak", "Normal"];